const breakpoints = {
  xs: '@media only screen and (min-width: 360px)',
  sm: '@media only screen and (min-width: 768px)',
  lg: '@media only screen and (min-width: 1200px)',
  xxl: '@media only screen and (min-width: 1400px)'
}

export { breakpoints }
